// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Formality from "../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as OrderType from "../../../../library/data-source/order/entity/OrderType.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as GeoRegionHook from "../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DeliveryNoteVm from "../../edit-order/view/view-model/DeliveryNoteVm.bs.js";
import * as Button$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Switch$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as CrmAssetsManager from "../../to-be-migrated/assets/CrmAssetsManager.bs.js";
import * as MsisdnValidation from "../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as WorkSpaceContext from "../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CheckBox$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/CheckBox.bs.js";
import * as FilterOrderSource from "../entity/FilterOrderSource.bs.js";
import * as FilterOrderStatus from "../entity/FilterOrderStatus.bs.js";
import * as Accordion$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as FilterOrderRequest from "../entity/FilterOrderRequest.bs.js";
import * as FormInput$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as MobileNumberValidation from "../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CircularLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var saveButton = CrmAssetsManager.getImage("save-button.svg");

var saveButtonDisabled = CrmAssetsManager.getImage("save-button-disabled.svg");

var validators_is_business = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      if (param.is_business) {
        return {
                TAG: /* Ok */0,
                _0: true
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_is_dn_requested = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      if (param.is_dn_requested) {
        return {
                TAG: /* Ok */0,
                _0: true
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_order_type = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var order_type = param.order_type;
      if (order_type !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: OrderType.fromString(order_type.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_geo_region = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var geo_region = param.geo_region;
      if (geo_region !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: geo_region.value
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_order_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var order_status = param.order_status;
      if (order_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: FilterOrderStatus.fromString(order_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_source = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var source = param.source;
      if (source !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: FilterOrderSource.fromString(source.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_driver_mobile = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, metadata) {
      var driver_mobile = param.driver_mobile;
      if (driver_mobile.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = MobileNumberValidation.execute(driver_mobile, metadata.country);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_msisdn = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, metadata) {
      var msisdn = param.msisdn;
      if (msisdn.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = MsisdnValidation.execute(msisdn, metadata.country);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_email = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var email = param.email;
      if (email.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = FormValidationUtils$Catalyst.validateEmail(email);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_customer_mobile = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, metadata) {
      var customer_mobile = param.customer_mobile;
      if (customer_mobile.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = MobileNumberValidation.execute(customer_mobile, metadata.country);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_order_id = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var order_id = param.order_id;
      if (order_id.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = FormValidationUtils$Catalyst.validateCRN(order_id);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators = {
  is_business: validators_is_business,
  is_dn_requested: validators_is_dn_requested,
  order_type: validators_order_type,
  geo_region: validators_geo_region,
  order_status: validators_order_status,
  source: validators_source,
  end_datetime: undefined,
  start_datetime: undefined,
  driver_mobile: validators_driver_mobile,
  msisdn: validators_msisdn,
  email: validators_email,
  customer_mobile: validators_customer_mobile,
  order_id: validators_order_id
};

function initialFieldsStatuses(_input) {
  return {
          is_business: /* Pristine */0,
          is_dn_requested: /* Pristine */0,
          order_type: /* Pristine */0,
          geo_region: /* Pristine */0,
          order_status: /* Pristine */0,
          source: /* Pristine */0,
          end_datetime: /* Pristine */0,
          start_datetime: /* Pristine */0,
          driver_mobile: /* Pristine */0,
          msisdn: /* Pristine */0,
          email: /* Pristine */0,
          customer_mobile: /* Pristine */0,
          order_id: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.is_business;
  var match_0 = match ? match._0 : Curry._2(validators.is_business.validate, input, metadata);
  var match$1 = fieldsStatuses.is_dn_requested;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.is_dn_requested.validate, input, metadata);
  var match$2 = fieldsStatuses.order_type;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.order_type.validate, input, metadata);
  var match$3 = fieldsStatuses.geo_region;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.geo_region.validate, input, metadata);
  var match$4 = fieldsStatuses.order_status;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.order_status.validate, input, metadata);
  var match$5 = fieldsStatuses.source;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.source.validate, input, metadata);
  var match_0$6 = {
    TAG: /* Ok */0,
    _0: input.end_datetime
  };
  var match_0$7 = {
    TAG: /* Ok */0,
    _0: input.start_datetime
  };
  var match$6 = fieldsStatuses.driver_mobile;
  var match_0$8 = match$6 ? match$6._0 : Curry._2(validators.driver_mobile.validate, input, metadata);
  var match$7 = fieldsStatuses.msisdn;
  var match_0$9 = match$7 ? match$7._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var match$8 = fieldsStatuses.email;
  var match_0$10 = match$8 ? match$8._0 : Curry._2(validators.email.validate, input, metadata);
  var match$9 = fieldsStatuses.customer_mobile;
  var match_0$11 = match$9 ? match$9._0 : Curry._2(validators.customer_mobile.validate, input, metadata);
  var match$10 = fieldsStatuses.order_id;
  var match_0$12 = match$10 ? match$10._0 : Curry._2(validators.order_id.validate, input, metadata);
  var is_businessResult = match_0;
  var is_businessResult$1;
  if (is_businessResult.TAG === /* Ok */0) {
    var is_dn_requestedResult = match_0$1;
    if (is_dn_requestedResult.TAG === /* Ok */0) {
      var order_typeResult = match_0$2;
      if (order_typeResult.TAG === /* Ok */0) {
        var geo_regionResult = match_0$3;
        if (geo_regionResult.TAG === /* Ok */0) {
          var order_statusResult = match_0$4;
          if (order_statusResult.TAG === /* Ok */0) {
            var sourceResult = match_0$5;
            if (sourceResult.TAG === /* Ok */0) {
              var end_datetimeResult = match_0$6;
              if (end_datetimeResult.TAG === /* Ok */0) {
                var start_datetimeResult = match_0$7;
                if (start_datetimeResult.TAG === /* Ok */0) {
                  var driver_mobileResult = match_0$8;
                  if (driver_mobileResult.TAG === /* Ok */0) {
                    var msisdnResult = match_0$9;
                    if (msisdnResult.TAG === /* Ok */0) {
                      var emailResult = match_0$10;
                      if (emailResult.TAG === /* Ok */0) {
                        var customer_mobileResult = match_0$11;
                        if (customer_mobileResult.TAG === /* Ok */0) {
                          var order_idResult = match_0$12;
                          if (order_idResult.TAG === /* Ok */0) {
                            return {
                                    TAG: /* Valid */0,
                                    output: {
                                      order_id: order_idResult._0,
                                      customer_mobile: customer_mobileResult._0,
                                      email: emailResult._0,
                                      msisdn: msisdnResult._0,
                                      driver_mobile: driver_mobileResult._0,
                                      start_datetime: start_datetimeResult._0,
                                      end_datetime: end_datetimeResult._0,
                                      source: sourceResult._0,
                                      order_status: order_statusResult._0,
                                      geo_region: geo_regionResult._0,
                                      order_type: order_typeResult._0,
                                      is_dn_requested: is_dn_requestedResult._0,
                                      is_business: is_businessResult._0
                                    },
                                    fieldsStatuses: {
                                      is_business: /* Dirty */{
                                        _0: is_businessResult,
                                        _1: /* Shown */0
                                      },
                                      is_dn_requested: /* Dirty */{
                                        _0: is_dn_requestedResult,
                                        _1: /* Shown */0
                                      },
                                      order_type: /* Dirty */{
                                        _0: order_typeResult,
                                        _1: /* Shown */0
                                      },
                                      geo_region: /* Dirty */{
                                        _0: geo_regionResult,
                                        _1: /* Shown */0
                                      },
                                      order_status: /* Dirty */{
                                        _0: order_statusResult,
                                        _1: /* Shown */0
                                      },
                                      source: /* Dirty */{
                                        _0: sourceResult,
                                        _1: /* Shown */0
                                      },
                                      end_datetime: /* Dirty */{
                                        _0: end_datetimeResult,
                                        _1: /* Hidden */1
                                      },
                                      start_datetime: /* Dirty */{
                                        _0: start_datetimeResult,
                                        _1: /* Hidden */1
                                      },
                                      driver_mobile: /* Dirty */{
                                        _0: driver_mobileResult,
                                        _1: /* Shown */0
                                      },
                                      msisdn: /* Dirty */{
                                        _0: msisdnResult,
                                        _1: /* Shown */0
                                      },
                                      email: /* Dirty */{
                                        _0: emailResult,
                                        _1: /* Shown */0
                                      },
                                      customer_mobile: /* Dirty */{
                                        _0: customer_mobileResult,
                                        _1: /* Shown */0
                                      },
                                      order_id: /* Dirty */{
                                        _0: order_idResult,
                                        _1: /* Shown */0
                                      }
                                    },
                                    collectionsStatuses: undefined
                                  };
                          }
                          is_businessResult$1 = is_businessResult;
                        } else {
                          is_businessResult$1 = is_businessResult;
                        }
                      } else {
                        is_businessResult$1 = is_businessResult;
                      }
                    } else {
                      is_businessResult$1 = is_businessResult;
                    }
                  } else {
                    is_businessResult$1 = is_businessResult;
                  }
                } else {
                  is_businessResult$1 = is_businessResult;
                }
              } else {
                is_businessResult$1 = is_businessResult;
              }
            } else {
              is_businessResult$1 = is_businessResult;
            }
          } else {
            is_businessResult$1 = is_businessResult;
          }
        } else {
          is_businessResult$1 = is_businessResult;
        }
      } else {
        is_businessResult$1 = is_businessResult;
      }
    } else {
      is_businessResult$1 = is_businessResult;
    }
  } else {
    is_businessResult$1 = is_businessResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            is_business: /* Dirty */{
              _0: is_businessResult$1,
              _1: /* Shown */0
            },
            is_dn_requested: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            order_type: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            geo_region: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            order_status: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            source: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            end_datetime: /* Dirty */{
              _0: match_0$6,
              _1: /* Hidden */1
            },
            start_datetime: /* Dirty */{
              _0: match_0$7,
              _1: /* Hidden */1
            },
            driver_mobile: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            },
            msisdn: /* Dirty */{
              _0: match_0$9,
              _1: /* Shown */0
            },
            email: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            customer_mobile: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            },
            order_id: /* Dirty */{
              _0: match_0$12,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurIs_businessField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.is_business, validators_is_business, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: status,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurIs_dn_requestedField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.is_dn_requested, validators_is_dn_requested, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: status,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOrder_typeField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.order_type, validators_order_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: status,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGeo_regionField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.geo_region, validators_geo_region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: status,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOrder_statusField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.order_status, validators_order_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSourceField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.source, validators_source, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEnd_datetimeField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.end_datetime, state.fieldsStatuses.end_datetime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: status,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_datetimeField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithoutValidator(state.input.start_datetime, state.fieldsStatuses.start_datetime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: status,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDriver_mobileField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.driver_mobile, validators_driver_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: status,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: status,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEmailField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: status,
                                  customer_mobile: init.customer_mobile,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCustomer_mobileField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.customer_mobile, validators_customer_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: status,
                                  order_id: init.order_id
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOrder_idField */12 :
                  var result$12 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.order_id, validators_order_id, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  is_business: init.is_business,
                                  is_dn_requested: init.is_dn_requested,
                                  order_type: init.order_type,
                                  geo_region: init.geo_region,
                                  order_status: init.order_status,
                                  source: init.source,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  driver_mobile: init.driver_mobile,
                                  msisdn: init.msisdn,
                                  email: init.email,
                                  customer_mobile: init.customer_mobile,
                                  order_id: status
                                };
                        }));
                  if (result$12 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$12,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */13 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */13,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */14,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */16);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */15);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */14 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */15 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */16 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateIs_businessField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.is_business, state.submissionStatus, validators_is_business, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: status,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateIs_dn_requestedField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.is_dn_requested, state.submissionStatus, validators_is_dn_requested, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: status,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOrder_typeField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.order_type, state.submissionStatus, validators_order_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: status,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGeo_regionField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.geo_region, state.submissionStatus, validators_geo_region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: status,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOrder_statusField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.order_status, state.submissionStatus, validators_order_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSourceField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.source, state.submissionStatus, validators_source, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEnd_datetimeField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.end_datetime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: status,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_datetimeField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$7.start_datetime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: status,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDriver_mobileField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$8, metadata, state.fieldsStatuses.driver_mobile, state.submissionStatus, validators_driver_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: status,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$9, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: status,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEmailField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$10, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: status,
                                            customer_mobile: init.customer_mobile,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCustomer_mobileField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$11, metadata, state.fieldsStatuses.customer_mobile, state.submissionStatus, validators_customer_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: status,
                                            order_id: init.order_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOrder_idField */12 :
                  var nextInput$12 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$12,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$12, metadata, state.fieldsStatuses.order_id, state.submissionStatus, validators_order_id, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            is_business: init.is_business,
                                            is_dn_requested: init.is_dn_requested,
                                            order_type: init.order_type,
                                            geo_region: init.geo_region,
                                            order_status: init.order_status,
                                            source: init.source,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            driver_mobile: init.driver_mobile,
                                            msisdn: init.msisdn,
                                            email: init.email,
                                            customer_mobile: init.customer_mobile,
                                            order_id: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */13 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */14 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */15 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateIs_business: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateIs_businessField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateIs_dn_requested: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateIs_dn_requestedField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOrder_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOrder_typeField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGeo_region: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGeo_regionField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOrder_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOrder_statusField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSource: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSourceField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEnd_datetime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_datetimeField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_datetime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_datetimeField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDriver_mobile: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDriver_mobileField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEmail: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEmailField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCustomer_mobile: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCustomer_mobileField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOrder_id: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOrder_idField */12,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurIs_business: (function (param) {
              return Curry._1(dispatch, /* BlurIs_businessField */0);
            }),
          blurIs_dn_requested: (function (param) {
              return Curry._1(dispatch, /* BlurIs_dn_requestedField */1);
            }),
          blurOrder_type: (function (param) {
              return Curry._1(dispatch, /* BlurOrder_typeField */2);
            }),
          blurGeo_region: (function (param) {
              return Curry._1(dispatch, /* BlurGeo_regionField */3);
            }),
          blurOrder_status: (function (param) {
              return Curry._1(dispatch, /* BlurOrder_statusField */4);
            }),
          blurSource: (function (param) {
              return Curry._1(dispatch, /* BlurSourceField */5);
            }),
          blurEnd_datetime: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_datetimeField */6);
            }),
          blurStart_datetime: (function (param) {
              return Curry._1(dispatch, /* BlurStart_datetimeField */7);
            }),
          blurDriver_mobile: (function (param) {
              return Curry._1(dispatch, /* BlurDriver_mobileField */8);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */9);
            }),
          blurEmail: (function (param) {
              return Curry._1(dispatch, /* BlurEmailField */10);
            }),
          blurCustomer_mobile: (function (param) {
              return Curry._1(dispatch, /* BlurCustomer_mobileField */11);
            }),
          blurOrder_id: (function (param) {
              return Curry._1(dispatch, /* BlurOrder_idField */12);
            }),
          is_businessResult: Formality.exposeFieldResult(state.fieldsStatuses.is_business),
          is_dn_requestedResult: Formality.exposeFieldResult(state.fieldsStatuses.is_dn_requested),
          order_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.order_type),
          geo_regionResult: Formality.exposeFieldResult(state.fieldsStatuses.geo_region),
          order_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.order_status),
          sourceResult: Formality.exposeFieldResult(state.fieldsStatuses.source),
          end_datetimeResult: Formality.exposeFieldResult(state.fieldsStatuses.end_datetime),
          start_datetimeResult: Formality.exposeFieldResult(state.fieldsStatuses.start_datetime),
          driver_mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.driver_mobile),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          emailResult: Formality.exposeFieldResult(state.fieldsStatuses.email),
          customer_mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.customer_mobile),
          order_idResult: Formality.exposeFieldResult(state.fieldsStatuses.order_id),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              var exit = 0;
              if (match.is_business || match.is_dn_requested || match.order_type || match.geo_region || match.order_status || match.source || match.end_datetime || match.start_datetime || match.driver_mobile || match.msisdn || match.email || match.customer_mobile) {
                exit = 1;
              } else {
                if (!match.order_id) {
                  return false;
                }
                exit = 1;
              }
              if (exit === 1) {
                var exit$1 = 0;
                exit$1 = 2;
                if (exit$1 === 2) {
                  return true;
                }
                
              }
              
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */13);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */14);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */15);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */15,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */16);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialState(filter) {
  return {
          order_id: Belt_Option.getWithDefault(filter.order_id, ""),
          customer_mobile: Belt_Option.getWithDefault(filter.customer_mobile, ""),
          email: Belt_Option.getWithDefault(filter.email, ""),
          msisdn: Belt_Option.getWithDefault(filter.msisdn, ""),
          driver_mobile: Belt_Option.getWithDefault(filter.driver_mobile, ""),
          start_datetime: filter.start_datetime,
          end_datetime: filter.end_datetime,
          source: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.source, FilterOrderSource.toString),
          order_status: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.order_status, FilterOrderStatus.toString),
          geo_region: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.geo_region, (function (a) {
                  return a;
                })),
          order_type: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.order_type, OrderType.toString),
          is_dn_requested: Belt_Option.getWithDefault(filter.is_dn_requested, false),
          is_business: Belt_Option.getWithDefault(filter.is_business, false)
        };
}

function isFormDirty(filter, formInput) {
  return Caml_obj.caml_notequal(formInput, getInitialState(filter));
}

function getValdationErrComp(validationError) {
  if (validationError !== undefined) {
    return React.createElement("p", {
                className: "error-server-msg"
              }, React.createElement("span", {
                    className: "error-msg"
                  }, validationError));
  } else {
    return null;
  }
}

var sourceOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(FilterOrderSource.source, FilterOrderSource.toString);

var orderStatusOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(FilterOrderStatus.status, FilterOrderStatus.toString);

var orderTypeOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(OrderType.orders, OrderType.toString);

function isFormValid(request) {
  var date_validation = Belt_Option.isSome(request.start_datetime) && Belt_Option.isSome(request.end_datetime) ? ({
        TAG: /* Ok */0,
        _0: "valid"
      }) : ({
        TAG: /* Error */1,
        _0: "Select date range"
      });
  if (request.order_id.length !== 0) {
    return {
            TAG: /* Ok */0,
            _0: "valid"
          };
  } else {
    return date_validation;
  }
}

function FilterOrderForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        
      });
  var updateError = match$1[1];
  var geoRegions = GeoRegionHook.useGeoRegions(country);
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var filterForm = useForm(getInitialState(filter), {
        country: country
      }, (function (output, _submissionCbs) {
          var filterPrarms_order_id = output.order_id;
          var filterPrarms_customer_mobile = output.customer_mobile;
          var filterPrarms_email = output.email;
          var filterPrarms_msisdn = output.msisdn;
          var filterPrarms_driver_mobile = output.driver_mobile;
          var filterPrarms_source = output.source;
          var filterPrarms_order_status = output.order_status;
          var filterPrarms_geo_region = output.geo_region;
          var filterPrarms_order_type = output.order_type;
          var filterPrarms_start_datetime = output.start_datetime;
          var filterPrarms_end_datetime = output.end_datetime;
          var filterPrarms_brand = /* Porter */0;
          var filterPrarms_virtual_number = filter.virtual_number;
          var filterPrarms_is_dn_requested = output.is_dn_requested;
          var filterPrarms_is_business = output.is_business;
          var filterPrarms = {
            order_id: filterPrarms_order_id,
            customer_mobile: filterPrarms_customer_mobile,
            email: filterPrarms_email,
            msisdn: filterPrarms_msisdn,
            driver_mobile: filterPrarms_driver_mobile,
            source: filterPrarms_source,
            order_status: filterPrarms_order_status,
            geo_region: filterPrarms_geo_region,
            order_type: filterPrarms_order_type,
            start_datetime: filterPrarms_start_datetime,
            end_datetime: filterPrarms_end_datetime,
            brand: filterPrarms_brand,
            virtual_number: filterPrarms_virtual_number,
            is_dn_requested: filterPrarms_is_dn_requested,
            is_business: filterPrarms_is_business
          };
          Curry._1(applyFilter, filterPrarms);
          return Curry._1(workspaceDispatch.replaceTab, {
                      TAG: /* FilterOrders */40,
                      _0: FilterOrderRequest.toDict(filterPrarms)
                    });
        }));
  React.useEffect((function () {
          Curry._1(filterForm.reset, undefined);
          
        }), [filter]);
  React.useEffect((function () {
          Curry._1(updateError, (function (param) {
                  
                }));
          
        }), [
        filterForm.input.end_datetime,
        filterForm.input.start_datetime,
        filterForm.input.order_id
      ]);
  var getSecondaryFiltersSection = function (param) {
    return React.createElement("div", {
                className: "accordian-content"
              }, React.createElement(FormTextInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Customer Email", (function ($$event) {
                            return Curry._2(filterForm.updateEmail, (function (input, value) {
                                          return {
                                                  order_id: input.order_id,
                                                  customer_mobile: input.customer_mobile,
                                                  email: value,
                                                  msisdn: input.msisdn,
                                                  driver_mobile: input.driver_mobile,
                                                  start_datetime: input.start_datetime,
                                                  end_datetime: input.end_datetime,
                                                  source: input.source,
                                                  order_status: input.order_status,
                                                  geo_region: input.geo_region,
                                                  order_type: input.order_type,
                                                  is_dn_requested: input.is_dn_requested,
                                                  is_business: input.is_business
                                                };
                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                          }), undefined, undefined, "Enter Customer Email", undefined, undefined, undefined, filterForm.emailResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    textinput_props: {
                      value: filterForm.input.email
                    }
                  }), React.createElement(FormSelectInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Source", (function ($$event) {
                            return Curry._2(filterForm.updateSource, (function (input, value) {
                                          return {
                                                  order_id: input.order_id,
                                                  customer_mobile: input.customer_mobile,
                                                  email: input.email,
                                                  msisdn: input.msisdn,
                                                  driver_mobile: input.driver_mobile,
                                                  start_datetime: input.start_datetime,
                                                  end_datetime: input.end_datetime,
                                                  source: value,
                                                  order_status: input.order_status,
                                                  geo_region: input.geo_region,
                                                  order_type: input.order_type,
                                                  is_dn_requested: input.is_dn_requested,
                                                  is_business: input.is_business
                                                };
                                        }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), sourceOptions));
                          }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    select_props: {
                      value: filterForm.input.source,
                      items: sourceOptions,
                      isNoneRequired: true
                    }
                  }), React.createElement(FormSelectInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Order Type", (function ($$event) {
                            return Curry._2(filterForm.updateOrder_type, (function (input, value) {
                                          return {
                                                  order_id: input.order_id,
                                                  customer_mobile: input.customer_mobile,
                                                  email: input.email,
                                                  msisdn: input.msisdn,
                                                  driver_mobile: input.driver_mobile,
                                                  start_datetime: input.start_datetime,
                                                  end_datetime: input.end_datetime,
                                                  source: input.source,
                                                  order_status: input.order_status,
                                                  geo_region: input.geo_region,
                                                  order_type: value,
                                                  is_dn_requested: input.is_dn_requested,
                                                  is_business: input.is_business
                                                };
                                        }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), orderTypeOptions));
                          }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    select_props: {
                      value: filterForm.input.order_type,
                      items: orderTypeOptions,
                      isNoneRequired: true
                    }
                  }), React.createElement(CheckBox$Catalyst.make, {
                    is_selected: filterForm.input.is_business,
                    onClick: (function (is_checked) {
                        return Curry._2(filterForm.updateIs_business, (function (input, value) {
                                      return {
                                              order_id: input.order_id,
                                              customer_mobile: input.customer_mobile,
                                              email: input.email,
                                              msisdn: input.msisdn,
                                              driver_mobile: input.driver_mobile,
                                              start_datetime: input.start_datetime,
                                              end_datetime: input.end_datetime,
                                              source: input.source,
                                              order_status: input.order_status,
                                              geo_region: input.geo_region,
                                              order_type: input.order_type,
                                              is_dn_requested: input.is_dn_requested,
                                              is_business: value
                                            };
                                    }), is_checked);
                      }),
                    text: "Business Order"
                  }));
  };
  switch (geoRegions.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var geoRegionOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(geoRegions._0, (function (x) {
                return x.name;
              }));
        var tmp;
        switch (country.TAG | 0) {
          case /* BD */2 :
          case /* MY */4 :
              tmp = null;
              break;
          default:
            tmp = React.createElement("div", {
                  className: "delivery-note-toggle"
                }, React.createElement("label", undefined, DeliveryNoteVm.getDNName(country) + " orders"), React.createElement(Switch$Catalyst.make, {
                      checked: filterForm.input.is_dn_requested,
                      on_change: (function (_event) {
                          var value = filterForm.input.is_dn_requested;
                          return Curry._2(filterForm.updateIs_dn_requested, (function (input, _value) {
                                        return {
                                                order_id: input.order_id,
                                                customer_mobile: input.customer_mobile,
                                                email: input.email,
                                                msisdn: input.msisdn,
                                                driver_mobile: input.driver_mobile,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                source: input.source,
                                                order_status: input.order_status,
                                                geo_region: input.geo_region,
                                                order_type: input.order_type,
                                                is_dn_requested: !value,
                                                is_business: input.is_business
                                              };
                                      }), !value);
                        }),
                      switch_color: /* Primary */1
                    }));
        }
        return React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "filter-order-form"
                      }, React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Order Id", (function ($$event) {
                                    return Curry._2(filterForm.updateOrder_id, (function (input, value) {
                                                  return {
                                                          order_id: value,
                                                          customer_mobile: input.customer_mobile,
                                                          email: input.email,
                                                          msisdn: input.msisdn,
                                                          driver_mobile: input.driver_mobile,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: input.order_status,
                                                          geo_region: input.geo_region,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), undefined, undefined, "Enter Order ID", undefined, undefined, undefined, filterForm.order_idResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: filterForm.input.order_id
                            }
                          }), React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("MSISDN", (function ($$event) {
                                    return Curry._2(filterForm.updateMsisdn, (function (input, value) {
                                                  return {
                                                          order_id: input.order_id,
                                                          customer_mobile: input.customer_mobile,
                                                          email: input.email,
                                                          msisdn: value,
                                                          driver_mobile: input.driver_mobile,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: input.order_status,
                                                          geo_region: input.geo_region,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), undefined, undefined, "Enter MSISDN", undefined, undefined, undefined, filterForm.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: filterForm.input.msisdn
                            }
                          }), React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Driver Mobile", (function ($$event) {
                                    return Curry._2(filterForm.updateDriver_mobile, (function (input, value) {
                                                  return {
                                                          order_id: input.order_id,
                                                          customer_mobile: input.customer_mobile,
                                                          email: input.email,
                                                          msisdn: input.msisdn,
                                                          driver_mobile: value,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: input.order_status,
                                                          geo_region: input.geo_region,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), undefined, undefined, "Enter Driver Mobile", undefined, undefined, undefined, filterForm.driver_mobileResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: filterForm.input.driver_mobile
                            }
                          }), React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Customer Mobile", (function ($$event) {
                                    return Curry._2(filterForm.updateCustomer_mobile, (function (input, value) {
                                                  return {
                                                          order_id: input.order_id,
                                                          customer_mobile: value,
                                                          email: input.email,
                                                          msisdn: input.msisdn,
                                                          driver_mobile: input.driver_mobile,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: input.order_status,
                                                          geo_region: input.geo_region,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), undefined, undefined, "Enter Customer Mobile", undefined, undefined, undefined, filterForm.customer_mobileResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: filterForm.input.customer_mobile
                            }
                          }), React.createElement("div", {
                            className: "filter-field-section"
                          }, React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Start Date", (function (param) {
                                        
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, filterForm.start_datetimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                date_props: {
                                  value: filterForm.input.start_datetime,
                                  minDate: undefined,
                                  maxDate: filterForm.input.end_datetime,
                                  onChange: (function (date) {
                                      return Curry._2(filterForm.updateStart_datetime, (function (input, value) {
                                                    return {
                                                            order_id: input.order_id,
                                                            customer_mobile: input.customer_mobile,
                                                            email: input.email,
                                                            msisdn: input.msisdn,
                                                            driver_mobile: input.driver_mobile,
                                                            start_datetime: value,
                                                            end_datetime: input.end_datetime,
                                                            source: input.source,
                                                            order_status: input.order_status,
                                                            geo_region: input.geo_region,
                                                            order_type: input.order_type,
                                                            is_dn_requested: input.is_dn_requested,
                                                            is_business: input.is_business
                                                          };
                                                  }), Caml_option.some(date));
                                    }),
                                  format: "DD/MM/YYYY hh:mm A",
                                  isDisabled: false,
                                  onClear: (function (param) {
                                      return Curry._2(filterForm.updateStart_datetime, (function (input, value) {
                                                    return {
                                                            order_id: input.order_id,
                                                            customer_mobile: input.customer_mobile,
                                                            email: input.email,
                                                            msisdn: input.msisdn,
                                                            driver_mobile: input.driver_mobile,
                                                            start_datetime: value,
                                                            end_datetime: input.end_datetime,
                                                            source: input.source,
                                                            order_status: input.order_status,
                                                            geo_region: input.geo_region,
                                                            order_type: input.order_type,
                                                            is_dn_requested: input.is_dn_requested,
                                                            is_business: input.is_business
                                                          };
                                                  }), undefined);
                                    })
                                }
                              })), React.createElement("div", {
                            className: "filter-field-section"
                          }, React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("End Date", (function (param) {
                                        
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, filterForm.end_datetimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                date_props: {
                                  value: filterForm.input.end_datetime,
                                  minDate: filterForm.input.start_datetime,
                                  maxDate: undefined,
                                  onChange: (function (date) {
                                      return Curry._2(filterForm.updateEnd_datetime, (function (input, value) {
                                                    return {
                                                            order_id: input.order_id,
                                                            customer_mobile: input.customer_mobile,
                                                            email: input.email,
                                                            msisdn: input.msisdn,
                                                            driver_mobile: input.driver_mobile,
                                                            start_datetime: input.start_datetime,
                                                            end_datetime: value,
                                                            source: input.source,
                                                            order_status: input.order_status,
                                                            geo_region: input.geo_region,
                                                            order_type: input.order_type,
                                                            is_dn_requested: input.is_dn_requested,
                                                            is_business: input.is_business
                                                          };
                                                  }), Caml_option.some(date));
                                    }),
                                  format: "DD/MM/YYYY h:mm A",
                                  isDisabled: false,
                                  onClear: (function (param) {
                                      return Curry._2(filterForm.updateEnd_datetime, (function (input, value) {
                                                    return {
                                                            order_id: input.order_id,
                                                            customer_mobile: input.customer_mobile,
                                                            email: input.email,
                                                            msisdn: input.msisdn,
                                                            driver_mobile: input.driver_mobile,
                                                            start_datetime: input.start_datetime,
                                                            end_datetime: value,
                                                            source: input.source,
                                                            order_status: input.order_status,
                                                            geo_region: input.geo_region,
                                                            order_type: input.order_type,
                                                            is_dn_requested: input.is_dn_requested,
                                                            is_business: input.is_business
                                                          };
                                                  }), undefined);
                                    })
                                }
                              })), React.createElement(FormSelectInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Order Status", (function ($$event) {
                                    return Curry._2(filterForm.updateOrder_status, (function (input, value) {
                                                  return {
                                                          order_id: input.order_id,
                                                          customer_mobile: input.customer_mobile,
                                                          email: input.email,
                                                          msisdn: input.msisdn,
                                                          driver_mobile: input.driver_mobile,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: value,
                                                          geo_region: input.geo_region,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), orderStatusOptions));
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            select_props: {
                              value: filterForm.input.order_status,
                              items: orderStatusOptions,
                              isNoneRequired: true
                            }
                          }), React.createElement(FormSelectInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Region", (function ($$event) {
                                    return Curry._2(filterForm.updateGeo_region, (function (input, value) {
                                                  return {
                                                          order_id: input.order_id,
                                                          customer_mobile: input.customer_mobile,
                                                          email: input.email,
                                                          msisdn: input.msisdn,
                                                          driver_mobile: input.driver_mobile,
                                                          start_datetime: input.start_datetime,
                                                          end_datetime: input.end_datetime,
                                                          source: input.source,
                                                          order_status: input.order_status,
                                                          geo_region: value,
                                                          order_type: input.order_type,
                                                          is_dn_requested: input.is_dn_requested,
                                                          is_business: input.is_business
                                                        };
                                                }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), geoRegionOptions));
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            select_props: {
                              value: filterForm.input.geo_region,
                              items: geoRegionOptions,
                              isNoneRequired: true
                            }
                          }), tmp), React.createElement(Accordion$Catalyst.make, {
                        panels: {
                          hd: AccordionTypes$Catalyst.make_props({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("div", {
                                                className: "accordion-header"
                                              }, React.createElement("p", {
                                                    className: "filter-field-section"
                                                  }, "Additional Filters"), React.createElement("p", {
                                                    className: "filter-field-section font-size-12 u-color-dark-grey"
                                                  }, "Email, Mobile, Source, Type..."));
                                  })
                              }, undefined, undefined, getSecondaryFiltersSection(undefined), undefined),
                          tl: /* [] */0
                        },
                        className: "accordion-container filter-order-accordion-container",
                        defaultOpen: 1
                      }), React.createElement("div", {
                        className: "apply-button-container"
                      }, getValdationErrComp(match$1[0]), React.createElement("div", {
                            className: "same-row-button"
                          }, React.createElement(Button$Catalyst.make, {
                                text: "Apply",
                                cb: (function (_event) {
                                    var _msg = isFormValid(filterForm.input);
                                    if (_msg.TAG === /* Ok */0) {
                                      return Curry._1(filterForm.submit, undefined);
                                    }
                                    var error = _msg._0;
                                    return Curry._1(updateError, (function (param) {
                                                  return error;
                                                }));
                                  }),
                                className: "btn-primary apply-button"
                              }))));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: geoRegions._0
                  });
    
  }
}

var make = FilterOrderForm;

export {
  saveButton ,
  saveButtonDisabled ,
  Form ,
  getInitialState ,
  isFormDirty ,
  getValdationErrComp ,
  sourceOptions ,
  orderStatusOptions ,
  orderTypeOptions ,
  isFormValid ,
  make ,
  
}
/* saveButton Not a pure module */
